module.exports = __webpack_public_path__ + "media/images/icon_tw_gray-cb068a9aaf1becb0e0f79a657a2c884f.png";